import { Language } from "../../reportMetaData/reportMetaDataHelper";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../../core/util/httpManager";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { General } from "../../../siteManagement/general";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Commands } from "../../core/util/commandManager";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { EmailHelper, Parameter } from "../emailHelper";
import { TextBox } from "../../core/components/textBox";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react"
import ReactDOM from "react-dom";
export default class DataGrid extends React.Component<DataGridProps, DataGridState>{
    private translations: StringKeyDictionary<string>;
    private gridOptions: kendo.ui.GridOptions;
    private types: { value: number; text: string, translation: string }[]
    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        };
        this.initApp();
    }

    private updateGridData = (gridData: GridRow[]) => {
        for (let i = 0; i < gridData.length; i++) {
            gridData[i].dataSourceName = Helper.hasValue(gridData[i].dataSourceId) ? gridData[i].dataSourceName : '';
        }
        this.setState({ gridData: gridData }, () => {
            let data = {};
            for (let i = 0; i < gridData.length; i++) {
                if (Helper.hasValue(gridData[i].dataSourceId) || !Helper.isNullOrEmpty(gridData[i].bodyTemplate) || !Helper.isNullOrEmpty(gridData[i].subjectTemplate)) {
                    data[gridData[i].languageCode] = {
                        BodyTemplate: gridData[i].bodyTemplate,
                        DataSourceId: gridData[i].dataSourceId,
                        SubjectTemplate: gridData[i].subjectTemplate
                    }
                }
            }
            this.props.onChange({ model: "entity.Data" }, data);
        })
    }

    private initApp = async () => {
        let results = await Promise.all([this.loadLanguages(), this.loadTranslations()]);
        this.translations = results[1];
        const keys = Object.keys(this.props.entity.Data);
        const gridData: GridRow[] = results[0].map((item) => {
            let row: GridRow;
            const key = keys.find(f => f.toLowerCase() == item.Code.toLowerCase());
            if (!Helper.isNullOrEmpty(key)) {
                const dataItem = this.props.entity.Data[key];
                row = {
                    bodyTemplate: dataItem.BodyTemplate,
                    dataSourceId: dataItem.DataSourceId,
                    dataSourceName: dataItem.DataSourceName,
                    subjectTemplate: dataItem.SubjectTemplate,
                    language: `${item.Displaynameen} (${item.Displaynamenative})`,
                    languageCode: item.Code
                };
            } else {
                row = {
                    dataSourceId: null,
                    dataSourceName: '',
                    language: `${item.Displaynameen} (${item.Displaynamenative})`,
                    languageCode: item.Code,
                    bodyTemplate: '',
                    subjectTemplate: ''
                }
            }
            return row;
        });
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "language",
                    title: this.translations["Field.Adresse.language"]
                },
                {
                    field: "languageCode",
                    title: this.translations["Standard.LanguageCode"]
                },
                {
                    field: "subjectTemplate",
                    title: this.translations["WebCRM.Email.Subject"]
                },
                {
                    field: "dataSourceName",
                    title: this.translations["WebCRM.Email.DataSource"]
                }
            ]
        };
        this.types = [
            {
                text: "servicereport",
                value: 1,
                translation: this.translations["BrowserTitle.Report.Available"]
            },
            {
                text: "weeklyreport",
                translation: this.translations["BrowserTitle.WeeklyReport.Available"],
                value: 2
            },
            {
                text: "customreport",
                translation: this.translations["WebSMS.ReportMetadata.TargetEntity.CustomReport"],
                value: 3
            },
            {
                text: "resourceplanning",
                translation: this.translations["BrowserTitle.Assigment.Available"],
                value: 4
            },
            {
                text: "machine",
                translation: this.translations["BrowserTitle.Machine.Available"],
                value: 5
            },
            {
                text: "resource",
                value: 6,
                translation: this.translations["BrowserTitle.Resource.Available"]
            },
            {
                text: "ticket",
                translation: this.translations["BrowserTitle.Ticket.Available"],
                value: 7
            },
            {
                text: "address",
                translation: this.translations["Adresse.Adresse"],
                value: 8
            },
            {
                text: "material",
                translation: this.translations["Vorgang.Material"],
                value: 9
            },
            {
                text: "project",
                translation: this.translations["Field.Vorgang.projnr"],
                value: 10
            },
            {
                text: "contact",
                translation: this.translations["WebSMS.ReportMetadata.TargetEntity.ContactPerson"],
                value: 11
            },
            {
                text: "usersettings",
                translation: this.translations["WebSMS.ReportMetadata.TargetEntity.User"],
                value: 12
            },
            {
                text: "travelExpenseReport",
                translation: this.translations["WebSMS.ReportMetadata.TargetEntity.TravelExpenseReport"],
                value: 13
            }
        ]
        this.types.push({
            text: "general",
            translation: this.translations["Server.Allgemein"],
            value: this.types.length + 1
        });
        
        this.setState({ gridData: gridData })
    }

    private loadLanguages = (): Promise<Language[]> => {
        return new Promise<Language[]>((resolve) => {
            const key = `email_languages`;
            let data = Helper.loadDataFromStorage(key);
            resolve(data);
        })
    }

    private loadTranslations = (): Promise<StringKeyDictionary<string>> => {
        const key = `emailTemplate_dataGrid_translations_${Config.user.languageId}`;
        const func = async () => {
            const keys = [
                "Field.Adresse.language",
                "WebCRM.Email.TemplateBody",
                "Standard.LanguageCode",
                "WebCRM.Email.Subject",
                "WebCRM.Email.TemplateSubject",
                "WebCRM.Email.DataSource",
                "BrowserTitle.Report.Available",
                "BrowserTitle.WeeklyReport.Available",
                "WebSMS.ReportMetadata.TargetEntity.CustomReport",
                "BrowserTitle.Assigment.Available",
                "BrowserTitle.Resource.Available",
                "BrowserTitle.Ticket.Available",
                "Adresse.Adresse",
                "Vorgang.Material",
                "Field.Vorgang.projnr",
                "Server.Allgemein",
                "WebCRM.Email.Template",
                "WebCRM.Email.TargetTypeWasSet",
                "WebCRM.Email.InvalidDatasource",
                "Standard.Kopieren",
                "BrowserTitle.Machine.Available",
                "WebSMS.ReportMetadata.TargetEntity.ContactPerson",
                "WebSMS.ReportMetadata.TargetEntity.User",
                "Standard.Execute",
                "WebCRM.Email.TemplateSubject",
                "WebCRM.Email.ChangeType",
                "Standard.Preview",
                "WebCRM.Email.InvalidDatasource",
                "WebCRM.Email.CopyFrom"
            ];
            const data = await HTTPService.post<JsonResultClass<StringKeyDictionary<string>>>("TranslationService/GetTranslations", { keys: keys });
            if (data.Code == 0) {
                return data.Data;
            } else {
                return null;
            }
        }

        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            let result = await EmailHelper.loadData(key, func);
            resolve(result)
        });
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            }
        ];

        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="emailTemplateData"
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                />
            </div>
        );
    }

    private onStandardClick = (type: ToolBarStandardButtonType, dataItem: GridRow) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.editRow(dataItem);
                break;
        }
    }

    private editRow = (row: GridRow) => {
        const getSearchUrl = () => {
            let url = "DynamicSearch/Window/emailDataSource/?fullObject=true";
            const entityType: string = Helper.getValueOrDefault(this.props.entity["Type"], "").toString();
            if (!Helper.isNullOrEmpty(entityType)) {
                url += `&type=${this.types.find(f => f.value == parseInt(entityType)).text}&disabled=type&disableType=true`;
            }
            return url;
        }

        const getNewUrl = () => {
            let url = "EmailSender/NewDataSource?isWindow=true";
            const entityType: string = Helper.getValueOrDefault(this.props.entity["Type"], "").toString();
            if (!Helper.isNullOrEmpty(entityType)) {
                url += `&type=${this.types.find(f => f.value == parseInt(entityType)).text}`;
            }
            return url;
        }

        const entity: DataRowEntity = {
            dataSourceId: row.dataSourceId,
            dataSourceName: row.dataSourceName,
            IsNew: false,
            IsWatchable: false,
            IsWatched: false,
            language: row.language,
            languageCode: row.languageCode,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            bodyTemplate: row.bodyTemplate,
            subjectTemplate: row.subjectTemplate,
            IndividualFields: null
        }

        const metaData: Metadata|any = {
            tabs: [
                {
                    title: "",
                    iconName: "",
                    regions: [
                        {
                            title: this.translations["WebCRM.Email.DataSource"],
                            visible: true,
                            fields: [
                                {
                                    type: "is-search-field",
                                    labelAndControlCombined: true,
                                    name: this.translations["WebCRM.Email.DataSource"],
                                    model: "entity.dataSourceId",
                                    readOnly: false,
                                    required: false,
                                    visible: true,
                                    readOnlyTextField: true,
                                    searchWindowUrl: getSearchUrl(),
                                    searchButtonEnabled: true,
                                    deleteButtonEnabled: true,
                                    newButtonEnabled: false,
                                    addNewUrl: getNewUrl()
                                },
                                {
                                    labelAndControlCombined: true,
                                    name: "Body",
                                    model: "entity.dataSourceName",
                                    readOnly: false,
                                    required: false,
                                    visible: true,
                                    type: "dynamic",
                                    moduleName: "app/email/dataSource/dataSourceDetails"
                                }
                            ]
                        },
                        {
                            title: this.translations["WebCRM.Email.Template"],
                            visible: true,
                            size: [
                                {
                                    container: "extrasmall",
                                    width: "12/12"
                                },
                                {
                                    container: "small",
                                    width: "12/12"
                                },
                                {
                                    container: "medium",
                                    width: "12/12"
                                },
                                {
                                    container: "large",
                                    width: "12/12"
                                },
                                {
                                    container: "extralarge",
                                    width: "12/12"
                                }
                            ],
                            fields: [
                                {
                                    type: "textbox",
                                    name: this.translations["WebCRM.Email.TemplateSubject"],
                                    model: "entity.subjectTemplate",
                                    readOnly: false,
                                    required: false,
                                    visible: true,
                                    leftContainerStyle: {
                                        "width": "150px"
                                    }

                                },
                                {
                                    labelAndControlCombined: true,
                                    name: "Body",
                                    model: "entity.bodyTemplate",
                                    readOnly: false,
                                    required: false,
                                    visible: true,
                                    type: "dynamic",
                                    moduleName: "app/email/emailEditor"
                                }
                            ]
                        }
                    ]
                }
            ],
            pageTitle: row.language,
            menuDataSource: [{
                type: "save"
            }, {
                text: this.translations["WebCRM.Email.CopyFrom"],
                onClick: "clone()",
                icon: "clone"
            },
            {
                text: this.translations["Standard.Execute"],
                onClick: "execute()",
                icon: "arrow-square-right",
                show: "showExecuteButton"
            }
            ],
            additional: {

            },
            rightDrawerContainer: {
                visible: true,
                width: 400,
                multipleComponents: [
                    {
                        moduleName: "app/core/components/iframe",
                        iconName: "question-circle",
                        renderAlways: true,
                        props: {
                            url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/administration/administrieren-der-anwendung/e-mail/e-mail-vorlage-erstellen"
                        }
                    }
                ]
            }
        };
        let props: EditDataRowProps = {
            parentType: this.props.entity["Type"],
            dataSources: null,
            entity: entity,
            isWindow: false,
            metadata: metaData as Metadata,
            title: "",
            translations: this.translations,
            context: {
                contextType: "",
            },
            getOtherRows: (code: string) => {
                return this.state.gridData.filter(f => f.languageCode != code);
            }
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(EditDataRow, props);
        });
        sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: DataRowEntity }) => {
            let gridData = this.state.gridData;
            const index = gridData.findIndex(f => f.languageCode.toLowerCase() == data.entity.languageCode.toLowerCase());
            gridData[index] = {
                dataSourceId: data.entity.dataSourceId,
                dataSourceName: data.entity.dataSourceName,
                language: data.entity.language,
                languageCode: data.entity.languageCode,
                bodyTemplate: data.entity.bodyTemplate,
                subjectTemplate: data.entity.subjectTemplate
            }
            this.updateGridData(gridData);
        });
    }

    render() {
        const grid = Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
        return grid;
    }
}

interface DataGridProps {
    entity: {
        Data: {}
    };
    onChange: (field, value) => void;
}

interface DataGridState {
    gridData: GridRow[];
}

interface GridRow {
    languageCode: string;
    language: string;
    bodyTemplate: string;
    subjectTemplate: string;
    dataSourceId: number;
    dataSourceName: string;
}

class EditDataRow extends React.Component<EditDataRowProps, EditDataRowState>{
    common = new AppHelper();
    showExecuteButton: boolean;
    private factory = ComponentHelper.createFactory();
    private possibleIds: number[];
    private possibleParameters: {};
    private parentType: number;
    private dialogProps: DialogProps = {
        title: "",
        width: 500,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.executeTemplate()
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false })
        }
    };
    constructor(props: EditDataRowProps) {
        super(props);
        this.common.init(this);
        this.parentType = props.parentType;
        this.state = {
            dialogOpen: false,
            parameters: []
        }
        this.setExecuteButtonVisibillity();
        this.initApp();
    }

    private initApp = async () => {
        this.loadPossibleIds();
        this.loadDataSourceQuery();
        this.possibleParameters = await EmailHelper.loadPossibleParameters();
        $(window).on("template_dataGrid_updateParentType", (_, data) => {
            this.parentType = data;
            this.loadPossibleIds();
        });
    }

    private setExecuteButtonVisibillity = () => {
        this.showExecuteButton = !Helper.isNullOrEmpty(this.props.entity.bodyTemplate) || !Helper.isNullOrEmpty(this.props.entity.subjectTemplate);
        this.setState({})
    }

    private loadPossibleIds = async () => {
        if (!Helper.isNullOrEmpty((this.parentType || "").toString())) {
            let result = await createHtppServiceInstance().noBusyIndicator().get<JsonResultClass<[]>>("EmailSender/GetDataSourcesByType?type=" + this.parentType);
            if (result.Code == 0) {
                this.possibleIds = result.Data.map(x => { return x["Id"] });
                this.setState({})
            }
        }
    }

    private loadDataSourceQuery = async () => {
        if (Helper.hasValue(this.props.entity.dataSourceId)) {
            let result = await createHtppServiceInstance().noBusyIndicator().get<JsonResultClass>("EmailSender/InitDataSource?id=" + this.props.entity.dataSourceId);
            this.loadParameters(result.Data.Content);
        }
    }

    private loadParameters = (query: string) => {
        this.setState({ parameters: EmailHelper.getParameters(query) })
    }

    private validate = () => {
        if (this.common.validate()) {
            if (!Helper.hasValue(this.props.entity.dataSourceId) || this.possibleIds.findIndex(f => f == this.props.entity.dataSourceId) > -1) {
                return true;
            } else {
                NotificationHelper.showWarningMessage(this.props.translations["WebCRM.Email.InvalidDatasource"]);
                return false;
            }
        } else {
            return false;
        }
    }

    save = () => {
        if (this.validate()) {
            this.common.handlePostSave(true, true);
            this.setState({});
        }
    }

    clone = () => {
        let dataItem = null;
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.props.getOtherRows(this.props.entity.languageCode);
        props.field.dataTextField = "language";
        props.field.dataValueField = "key";
        props.onChange = (_, __, item) => {
            dataItem = item;
        }
        const targetElement = $("<div>");
        const dialogProps: DialogProps = {
            title: Helper.getTranslation("WebCRM.Email.CopyFrom"),
            width: 300,
            actions: [
                {
                    label: Config.translations.cancel,
                    action: () => { }
                },
                {
                    label: Config.translations.ok,
                    action: () => {
                        let entity = this.props.entity;
                        entity.dataSourceId = dataItem.dataSourceId;
                        entity.dataSourceName = dataItem.dataSourceName;
                        entity.bodyTemplate = dataItem.bodyTemplate;
                        entity.subjectTemplate = dataItem.subjectTemplate;
                        Helper.updateEntity(this.props.entity, entity);
                        this.common.setEntityDirtyState(true, () => { this.setState({}) });
                    },
                    primary: true
                }
            ],
            afterClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
        };
        $("body").append(targetElement);
        ReactDOM.render(
            <Dialog {...dialogProps} open={true}>
                <FieldInstance label={this.props.translations["Field.Adresse.language"]}><DropDownList {...props} /></FieldInstance>
            </Dialog >, targetElement[0]);
    }

    execute = () => {
        const possibleParams: { Name: string, TypeKind: number }[] = this.possibleParameters[this.parentType];
        let count = possibleParams.filter(f1 => this.state.parameters.findIndex(f2 => EmailHelper.getName(f2.name) == f1.Name) > -1).length;
        if (this.state.parameters.length > 0 && count > 0) {
            this.setState({ dialogOpen: true })
        } else {
            this.executeTemplate();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
            this.setExecuteButtonVisibillity()
        }
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        switch (field.model) {
            case "entity.dataSourceId":
                this.handleFieldChange({ model: "entity.dataSourceId" }, dataItem["id"]);
                this.handleFieldChange({ model: "entity.dataSourceName" }, dataItem["name"]);
                this.loadParameters(dataItem["sourceBody"])
                this.loadPossibleIds();
                break;
        }
    }

    componentDidMount() {
        this.common.commandManager.runCommand("htmlEditor", Commands.REFRESH);
    }

    private createDialog = () => {
        return (
            <Dialog {...this.dialogProps} open={true} title={Helper.getTranslation("WebSMS.Title.TemplateEditing.ExecuteTemplate")}>
                {this.createInputElements()}
            </Dialog>
        );
    }

    private createInputElements = () => {
        const possibleParams: { Name: string, TypeKind: number }[] = this.possibleParameters[this.parentType];
        const createInput = (param: { Name: string, TypeKind: number }) => {
            const value = this.state.parameters.find(f => EmailHelper.getName(f.name) == param.Name).value;
            const onChange = (_, value) => {
                const index = this.state.parameters.findIndex(f => EmailHelper.getName(f.name) == param.Name);
                let params = this.state.parameters;
                params[index].value = value;
            }
            let input: JSX.Element;
            switch (param.TypeKind) {
                case 2:
                    let tbProps = this.factory.getDefaultTextBoxProps();
                    tbProps.value = (value || "");
                    tbProps.onChange = onChange
                    input = <><TextBox {...tbProps} /></>
                    break;
                default:
                    let nbProps = this.factory.getDefaultNumericTextBoxProps();
                    nbProps.value = (value || 0);
                    nbProps.onChange = onChange
                    nbProps.field.decimals = param.TypeKind == 0 ? 0 : 1;
                    input = <><IsNumericTextBox {...nbProps} /></>
                    break;
            }
            return (
                <React.Fragment key={kendo.guid()}>
                    <FieldInstance label={param.Name}>
                        {input}
                    </FieldInstance>
                </React.Fragment>
            );
        }
        return possibleParams.filter(f1 => this.state.parameters.findIndex(f2 => EmailHelper.getName(f2.name) == f1.Name) > -1).map(createInput);
    }

    private executeTemplate = async () => {
        let parameters = {};
        for (let i = 0; i < this.state.parameters.length; i++) {
            parameters[EmailHelper.getName(this.state.parameters[i].name)] = this.state.parameters[i].value;
        }
        let result = await HTTPService.post<JsonResultClass<{}>>("EmailSender/CreateEmailPreview", {
            subject: this.props.entity.subjectTemplate,
            body: this.props.entity.bodyTemplate,
            languageCode: this.props.entity.languageCode,
            dataSourceId: this.props.entity.dataSourceId,
            parameters: parameters
        })
        if (result.Code == 1) {
            NotificationHelper.showErrorMessage(result.Message);
        } else {
            const targetElement = $("<div>");
            const props: DialogProps = {
                title: this.props.translations["Standard.Preview"],
                actions: [],
                afterClose: () => {
                    ReactDOM.unmountComponentAtNode(targetElement[0]);
                    targetElement[0].remove();
                },
                closable: true,
                height: 250,
                maxHeight: 500
            }
            $("body").append(targetElement);
            ReactDOM.render(
                <Dialog {...props} open={true}>
                    <div
                        className={"emailTemplate__preview"}
                        style={{ maxHeight: "600px", paddingLeft: "12px", minWidth: "150px" }}
                        dangerouslySetInnerHTML={{ __html: `<div><div style="margin-bottom: 15px">${this.props.translations["WebCRM.Email.TemplateSubject"]}: ${result.Data["subject"]}</div><div>${result.Data["body"]}</div></div>` }}>
                    </div>
                </Dialog >, targetElement[0], () => {
                    let dialog = document.querySelector('[role="dialog"]') as HTMLElement;
                    dialog.style.top = ((window.innerHeight - dialog.offsetHeight) / 2).toString() + "px";
                    dialog.style.left = ((window.innerWidth - dialog.offsetWidth) / 2).toString() + "px";
                });
        }
    }

    componentDidUpdate() {
        this.parentType = this.props.parentType;
    }

    render() {
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <><CommonApp {...props} />{dialog}</>;
    }
}

interface EditDataRowProps extends AppBaseProps {
    entity: DataRowEntity;
    parentType: number;
    translations: StringKeyDictionary<string>;
    getOtherRows: (code: string) => GridRow[];
}

interface EditDataRowState {
    dialogOpen: boolean;
    parameters: Parameter[];
}

interface DataRowEntity extends Entity, GridRow { }